import * as React                                     from "react";
import { openNotification }                           from "../components/NotificationsContainer";
import { NotificationComponent, NotificationOptions } from "../interfaces/notifications";

export default <Props extends {}>(component: NotificationComponent<Props>) => {
  return (props: Props, options?: NotificationOptions) => openNotification(component, props, options);
}
